import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from '../../config/app-settings.js';

function Confirmacao() {
	const context = useContext(AppSettings);
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);

	return (
		<div className="error-page">
			<div className="error-page-content">
				
				<h1 className="mb-3">Estamos quase lá!</h1> 
				<h3 className="mb-2">Confirme sua participação e finalize sua inscrição abaixo</h3>
				<Link target='_blank' to="https://chat.whatsapp.com/C3HCRnC52IC3aWEZGgRo1c" className="btn btn-theme mt-3 text-uppercase btn-sm py-2 fs-11px">Finalizar inscrição</Link>
			</div>
		</div>
	)
}

export default Confirmacao;